import { useEffect } from 'react'
import { createPortal } from 'react-dom'

export function Modal({ children, onClose }) {
  useEffect(() => {
    document.body.style.overflowY = 'hidden'
    return () => {
      document.body.style.overflowY = 'auto'
    }
  }, [])

  return createPortal(
    <div
      className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-85 z-50"
      onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside the modal
      >
        {/* Close Button */}
        {children}
      </div>
    </div>,
    document.body
  )
}
